import React, {useEffect} from "react"
import styles from "./modal.module.scss"
import MaterialIcon from "../material-icon/material-icon-view"
import {HeadingLarge} from "../heading/heading"

interface ModalProps {
  title?: string
  closeModal?: () => void
  show: boolean
  minHeight?: "70"
}

export const Modal: React.FC<ModalProps> = ({title, closeModal, show, minHeight, children}) => {
  // disable scrolling the page when the modal is open
  useEffect(() => {
    const body: HTMLElement | null = document?.querySelector("body")

    if (show) {
      body?.setAttribute("style", "overflow: hidden;")
    } else {
      body?.setAttribute("style", "")
    }
  }, [show])

  if (!show) return null

  return (
    <div className={styles.DarkBackground}>
      <div className={minHeight === "70" ? styles.FrameMinHeight70 : styles.Frame}>
        <button className={styles.CloseButton} onClick={closeModal}>
          <MaterialIcon name="close" size="large"/>
        </button>
        <div className={title ? styles.ContentWithTitle : styles.ContentWithoutTitle}>
          {
            title
              ? <HeadingLarge>{title}</HeadingLarge>
              : <></>
          }
          <div>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

